module.exports = __webpack_public_path__ + "static/media/floor-layout.642648fc.png";